import { Link } from "react-router-dom";

const base =
  "inline-flex items-center justify-center gap-2 text-sm font-medium tracking-wide transition-all duration-[400ms] [transition-timing-function:cubic-bezier(0.22,1,0.36,1)] disabled:opacity-50 disabled:cursor-not-allowed";

const variants = {
  primary:
    "rounded-full bg-terracotta px-7 py-3.5 text-cream hover:bg-[#A64826] hover:-translate-y-[1px] shadow-[0_1px_0_rgba(0,0,0,0.04)]",
  secondary:
    "rounded-full border border-charcoal/80 px-7 py-3.5 text-charcoal hover:bg-charcoal hover:text-cream",
  outlineCream:
    "rounded-full border border-cream/60 px-7 py-3.5 text-cream backdrop-blur-[2px] hover:bg-cream hover:text-charcoal",
  ghost:
    "relative px-0 py-2 text-charcoal hover:text-terracotta after:absolute after:left-0 after:-bottom-0.5 after:h-px after:w-full after:bg-current after:scale-x-0 after:origin-left hover:after:scale-x-100 after:transition-transform after:duration-[400ms]",
  link: "underline underline-offset-4 decoration-current hover:text-terracotta",
};

export default function Button({
  as = "button",
  to,
  href,
  variant = "primary",
  children,
  className = "",
  ...props
}) {
  const cls = `${base} ${variants[variant]} ${className}`;
  if (to) {
    return (
      <Link to={to} className={cls} {...props}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} {...props}>
        {children}
      </a>
    );
  }
  const Comp = as;
  return (
    <Comp className={cls} {...props}>
      {children}
    </Comp>
  );
}
